import { useState } from "react";
import { Menu, X } from "lucide-react";

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-md" data-testid="header">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 bg-gradient-to-br from-amber-500 to-amber-700 rounded-full flex items-center justify-center">
              <span className="text-white font-bold text-xl">BG</span>
            </div>
            <div>
              <h1 className="text-lg md:text-xl font-bold text-gray-900" style={{ fontFamily: "'Playfair Display', serif" }}>
                Banner of Grace
              </h1>
              <p className="text-xs text-gray-600" style={{ fontFamily: "'Crimson Text', serif" }}>
                International Gospel Ministry
              </p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection("home")} className="text-gray-700 hover:text-amber-700 font-medium transition-colors" data-testid="nav-home">
              Home
            </button>
            <button onClick={() => scrollToSection("about")} className="text-gray-700 hover:text-amber-700 font-medium transition-colors" data-testid="nav-about">
              About
            </button>
            <button onClick={() => scrollToSection("programs")} className="text-gray-700 hover:text-amber-700 font-medium transition-colors" data-testid="nav-programs">
              Programs
            </button>
            <button onClick={() => scrollToSection("events")} className="text-gray-700 hover:text-amber-700 font-medium transition-colors" data-testid="nav-events">
              Events
            </button>
            <button onClick={() => scrollToSection("donate")} className="px-6 py-2 bg-amber-600 text-white rounded-full hover:bg-amber-700 font-medium transition-colors" data-testid="nav-donate">
              Donate
            </button>
            <button onClick={() => scrollToSection("contact")} className="text-gray-700 hover:text-amber-700 font-medium transition-colors" data-testid="nav-contact">
              Contact
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 text-gray-700 hover:text-amber-700 transition-colors"
            data-testid="mobile-menu-button"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 border-t border-gray-200 pt-4 space-y-3" data-testid="mobile-menu">
            <button onClick={() => scrollToSection("home")} className="block w-full text-left py-2 text-gray-700 hover:text-amber-700 font-medium transition-colors">
              Home
            </button>
            <button onClick={() => scrollToSection("about")} className="block w-full text-left py-2 text-gray-700 hover:text-amber-700 font-medium transition-colors">
              About
            </button>
            <button onClick={() => scrollToSection("programs")} className="block w-full text-left py-2 text-gray-700 hover:text-amber-700 font-medium transition-colors">
              Programs
            </button>
            <button onClick={() => scrollToSection("events")} className="block w-full text-left py-2 text-gray-700 hover:text-amber-700 font-medium transition-colors">
              Events
            </button>
            <button onClick={() => scrollToSection("donate")} className="block w-full text-left py-2 px-6 bg-amber-600 text-white rounded-full hover:bg-amber-700 font-medium transition-colors">
              Donate
            </button>
            <button onClick={() => scrollToSection("contact")} className="block w-full text-left py-2 text-gray-700 hover:text-amber-700 font-medium transition-colors">
              Contact
            </button>
          </nav>
        )}
      </div>
    </header>
  );
};